module.exports = __webpack_public_path__ + "img/6-9.47b76b32.png";